import AxiosClient from "../../../services/axios.services";

class MantIndikServices {
  getMantIndiks = params =>
    AxiosClient.get("/api/app/descriptor_perfil_indicador/", {
      headers: { "Content-Type": "application/json" },
      params: params,
    });
  getMantIndik = id =>
    AxiosClient.get(`/api/app/descriptor_perfil_indicador/${id}/`, {
      headers: { "Content-Type": "application/json" },
  });
  saveMantIndik = req =>
    AxiosClient.post("/api/app/descriptor_perfil_indicador/", req, {
      headers: { "Content-Type": "application/json" },
    });
  editMantIndik = (id, req) =>
    AxiosClient.put(`/api/app/descriptor_perfil_indicador/${id}/`, req, {
      headers: { "Content-Type": "application/json" },
    });
  deleteMantIndik = id =>
    AxiosClient.delete(`/api/app/descriptor_perfil_indicador/${id}`, {
      headers: { "Content-Type": "application/json" },
    });
}

export default new MantIndikServices();